import React from 'react';
import { Route } from 'react-router-dom';

const RouteWithProps = ({ props, component: Component, ...rest }: $TSFixMe) => (
    <Route
        {...rest}
        exact
        render={(matchProps: $TSFixMe) => <Component {...matchProps} {...props} />}
    />
);

export default RouteWithProps;
